import Skeleton from "react-loading-skeleton";

const RecentlyDeletedSkeleton = () => {
    const theme = localStorage.getItem("theme") || "light";
    const skeletonColors = theme === "dark"
        ? { baseColor: "#1A1C23", highlightColor: "#2C313D" }
        : { baseColor: "#E1E7EF", highlightColor: "#F2F4F7" };

    return (
        <div className="space-y-5">
            {/* Info card skeleton */}
            <div className="rounded-3xl border border-transparent bg-gradient-to-br from-gray-100 to-gray-200 dark:from-[#111111] dark:to-[#0F0F0F] p-4">
                <Skeleton {...skeletonColors} height={14} width="85%" borderRadius={12} />
                <div className="mt-2">
                    <Skeleton {...skeletonColors} height={14} width="70%" borderRadius={12} />
                </div>
                <div className="mt-3">
                    <Skeleton {...skeletonColors} height={36} width={180} borderRadius={999} />
                </div>
            </div>

            {/* Grid skeleton */}
            <div className="grid grid-cols-3 gap-1.5 overflow-scroll no-scrollbar">
                {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((data) => (
                    <div
                        key={data}
                        className="col-span-1 w-full h-[45vw] md:h-[9vw]"
                    >
                        <Skeleton
                            {...skeletonColors}
                            width="100%"
                            height="100%"
                            style={{ borderRadius: "0.5rem" }}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default RecentlyDeletedSkeleton;
